import React, { useEffect, useState } from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import avatecLogo from '../../assets/logos/avatec-white.png';
import './Slide14SpareParts.css';

const capabilities = [
  'Strategic stock positioning to minimize vessel downtime',
  'Critical spare availability for essential marine systems',
  '24/7 material readiness for urgent operational needs',
  'Express dispatch capability for rapid global mobilization',
  'Pre-staged materials supporting newbuilding and retrofit projects',
  'Inventory traceability ensuring controlled and transparent material flow',
];

function Slide14SpareParts() {
  const prefersReduced = useReducedMotion();
  const reduceMotion = !!prefersReduced;
  const [isVisible, setIsVisible] = useState(false);
  const ease: [number, number, number, number] = [0.25, 0.46, 0.45, 0.94];

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const fadeUp = (delay = 0) =>
    reduceMotion
      ? { initial: { opacity: 1 }, animate: { opacity: 1 } }
      : {
          initial: { opacity: 0, y: 18 },
          animate: isVisible ? { opacity: 1, y: 0 } : {},
          transition: { duration: 0.7, delay, ease },
        };

  return (
    <div className="slide slide-spare-parts">
      <img src={avatecLogo} alt="Avatec Marine" className="slide-logo" />

      <div className="spare-bg">
        <div className="spare-grid" />
        <div className="spare-curve" />
        <div className="spare-glow spare-glow-left" />
        <div className="spare-glow spare-glow-right" />
        <div className="spare-noise" />
      </div>

      <div className="spare-content">
        <motion.div className="spare-header" {...fadeUp(0.05)}>
          <h1>Spare Parts Supply</h1>
          <p>
            AVATEC maintains strategically managed logistics infrastructure to ensure rapid material availability for
            vessel operations, service activities, and project deployments.
          </p>
          <span className="spare-tag">We maintain spare parts stock at all times</span>
        </motion.div>

        <motion.div className="spare-metrics" {...fadeUp(0.12)}>
          <div className="spare-metric">
            <div className="metric-value">5</div>
            <div className="metric-label">Warehouse facilities</div>
          </div>
          <div className="metric-divider" />
          <div className="spare-metric">
            <div className="metric-value">20</div>
            <div className="metric-label">Dedicated logistics personnel</div>
          </div>
        </motion.div>

        <motion.div className="spare-section" {...fadeUp(0.2)}>
          <div className="spare-section-label">Logistics capabilities</div>
          <ul className="spare-list">
            {capabilities.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </motion.div>
      </div>
    </div>
  );
}

export default Slide14SpareParts;
